import {
  REGISTER_FOR_NOTIFICATIONS_FAILURE,
  REGISTER_FOR_NOTIFICATIONS_SUCCESS,
  REGISTER_FOR_NOTIFICATIONS_START,
  SEND_NOTIFICATIONS_FAILURE,
  SEND_NOTIFICATIONS_SUCCESS,
  SEND_NOTIFICATIONS_START,
  FETCH_NOTIFICATIONS_FAILURE,
  FETCH_NOTIFICATIONS_SUCCESS,
  FETCH_NOTIFICATIONS_START,
} from "../store/types";


import { store } from "../store/store";

import {
  cloud_function_server_url,
} from "config";

export const registerForPushNotificationsAsync =
  (Constants, Notifications, isDevice) => (dispatch) => async (firebase) => {
    try {
      dispatch({
        type: REGISTER_FOR_NOTIFICATIONS_START,
        payload: null,
      });
      let token;
      if (isDevice) {
        const { status: existingStatus } =
          await Notifications.getPermissionsAsync();
        let finalStatus = existingStatus;
        if (existingStatus !== "granted") {
          const { status } = await Notifications.requestPermissionsAsync();
          finalStatus = status;
        }
        token = (
          await Notifications.getExpoPushTokenAsync({
            projectId: Constants.expoConfig.extra.eas.projectId,
          })
        ).data;
      } else {
        console.log("must be");
        dispatch({
          type: REGISTER_FOR_NOTIFICATIONS_FAILURE,
          payload: null,
        });
      }

      if (token) {
        console.log("token", token);
        dispatch({
          type: REGISTER_FOR_NOTIFICATIONS_SUCCESS,
          payload: token,
        });
      }
    } catch (error) {
      console.log("error", error);
      dispatch({
        type: REGISTER_FOR_NOTIFICATIONS_FAILURE,
        payload: error,
      });
    }
  };

export const FetchusersPushNotification = (UserId) => async (dispatch) => {
  try {
    dispatch({
      type: FETCH_NOTIFICATIONS_START,
      payload: null,
    });
    var notref = database.ref(`Notifications/${UserId}`);
    notref.on("value", (snapshot) => {
      const data = snapshot.val();
      if (data) {
        const notes = Object.values(data);
        notes.sort((a, b) => b.createdAt - a.createdAt);
        dispatch({
          type: FETCH_NOTIFICATIONS_SUCCESS,
          payload: notes,
        });
      }
    });
  } catch (error) {
    dispatch({
      type: FETCH_NOTIFICATIONS_FAILURE,
      payload: error,
    });
  }
};

export const SendPushNotification =
  (notification) => (dispatch) => async (firebase) => {
    try {
      dispatch({
        type: SEND_NOTIFICATIONS_START,
        payload: null,
      });

      console.log("notification", notification);
      let headersList = {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Headers": "Content-Type",
        "Content-Type": "application/json",
      };

      let bodyContent;



      let response = await fetch(
        `${cloud_function_server_url}/send_notification`, //changed the function URL to the api send_notification
        {
          method: "POST",
          body: JSON.stringify({
            token: notification.expoPushToken,
            title: notification.title,
            msg: notification.msg,
            UserId: notification.userId,
            content: notification.content,
          }),
          headers: headersList,
        }
      );

      let data = await response.text();
      console.log("data", data);
    } catch (error) {
      dispatch({
        type: SEND_NOTIFICATIONS_FAILURE,
        payload: error,
      });
    }
  };


/**
 * 
 * Send a push notification to the brokers in an office about a message that was sent on an enquiry 
 * 
 * @param {notificationInfomation}  notificationInfomation holds the infomation that needs to be sent to the Broker such as Who sent the message
 * @param {brokerIgnoreList} List of brokers who must not recive the notification 
 * 
 *  
 */

export const SendEnquiryGroupChatNotification =
  (notificationInfomation, brokerIgnoreList) => (dispatch) => async (firebase) => {
    const { userOfficeRef, auth } = firebase;

    try {
      dispatch({
        type: SEND_NOTIFICATIONS_START,
        payload: null,
      });

      console.log('brokerIgnoreList', brokerIgnoreList);
      console.log('notificationInfomation', notificationInfomation);

      userOfficeRef(notificationInfomation.office)
        .once("value", (snapshot) => {
          let data = Object.values(snapshot.val());
          let keys = Object.keys(snapshot.val());



          let Brokers = [];
          for (let index = 0; index < data.length; index++) {

            const element = data[index];

            if (!brokerIgnoreList.find(x => x.brokerId === keys[index])) {
              Brokers.push({
                expoPushToken: element?.deviceInfo?.expopushtoken
                  ? element?.deviceInfo?.expopushtoken
                  : null,
                userId: keys[index] ? keys[index] : null,
              });
            }



            if (index === data.length - 1) {
              if (Brokers.length !== 0) {


                fetch(
                  `${cloud_function_server_url}/send_bulk_notification`,
                  {
                    method: "POST",
                    headers: {
                      "Content-Type": "application/json",
                    },
                    body: JSON.stringify({
                      students: Brokers,
                      title: notificationInfomation.title,
                      msg: notificationInfomation.msg,
                      content: notificationInfomation.content,
                    }),
                  }
                )
                  .then((response) => response?.json())
                  .then((results) => {
                    if (results) {
                      let fullamount = results.arr.length;
                      let succuss = 0;
                      results.arr.forEach((result) => {
                        if (result.status === "ok") succuss++;
                      });
                    }
                  })
                  .catch((error) => {
                    console.error("Error:", error);
                  });
              } else {
                Alert.alert("No Brokers Found");
              }
            }
          }
        })
    } catch (error) {

      console.log('error', error)

      dispatch({
        type: SEND_NOTIFICATIONS_FAILURE,
        payload: error,
      });
    }
  };






const getBrokersFromRegions = async (region, auth) => {


  let selectedBrokers = [];

  let areas = Object.values(region.areas);

  for (const area of areas) {
    const Brokers = store.getState().brokers.users;

    for (let index = 0; index < Brokers.length; index++) {
      const broker = Brokers[index];
      let brokerAreas = Object.keys(broker?.Areas ? broker.Areas : {});

      if (brokerAreas.includes(area) && auth.currentUser.uid !== broker.id) {
        selectedBrokers.push({
          expoPushToken: broker?.deviceInfo?.expopushtoken
            ? broker?.deviceInfo?.expopushtoken
            : null,
          userId: broker?.id ? broker?.id : null,
        });
      }


      if (index === Brokers.length - 1) {
        return selectedBrokers;
      }



    }


  }
}

export const SendBulkPushNotification =
  (notification) => (dispatch) => async (firebase) => {
    const { userOfficeRef, auth, SingleRegionRef } = firebase;

    try {
      dispatch({
        type: SEND_NOTIFICATIONS_START,
        payload: null,
      });

      if (notification.office) {
        userOfficeRef(notification.office)
          .once("value", (snapshot) => {
            let data = Object.values(snapshot.val());
            let keys = Object.keys(snapshot.val());

            let Brokers = [];
            for (let index = 0; index < data.length; index++) {
              const element = data[index];
              if (auth.currentUser.uid !== keys[index]) {
                Brokers.push({
                  expoPushToken: element?.deviceInfo?.expopushtoken
                    ? element?.deviceInfo?.expopushtoken
                    : null,
                  userId: keys[index] ? keys[index] : null,
                });
              }
              if (index === data.length - 1) {
                if (Brokers.length !== 0) {



                  fetch(
                    `${cloud_function_server_url}/send_bulk_notification`,
                    {
                      method: "POST",
                      headers: {
                        "Content-Type": "application/json",
                      },
                      body: JSON.stringify({
                        students: Brokers,
                        title: notification.title,
                        msg: notification.msg,
                        content: notification.content,
                      }),
                    }
                  )
                    .then((response) => response?.json())
                    .then((results) => {

                    })
                    .catch((error) => {
                      console.error("Error:", error);
                    });
                } else {
                  Alert.alert("No Brokers Found");
                }
              }
            }
          })
          .then((Brokers) => { });
      }


      if (notification.brokers) {

        const selectedBrokers = [];

        const Brokers = store.getState().brokers.users;

        for (let index = 0; index < Brokers.length; index++) {
          const broker = Brokers[index];

          if (notification.brokers.includes(broker.id) && auth.currentUser.uid !== broker.id) {
            selectedBrokers.push({
              expoPushToken: broker?.deviceInfo?.expopushtoken
                ? broker?.deviceInfo?.expopushtoken
                : null,
              userId: broker?.id ? broker?.id : null,
            });
          }


          if (index === Brokers.length - 1) {
            if (selectedBrokers.length !== 0) {

              console.log("sending notifications", selectedBrokers)
              fetch(
                `${cloud_function_server_url}/send_bulk_notification`
                ,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    students: selectedBrokers,
                    title: notification.title,
                    msg: notification.msg,
                    content: notification.content,
                  }),
                }
              )
                .then((response) => response?.json())
                .then((results) => {

                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            }
          }
        }
      }

      if (notification.region) {

        SingleRegionRef(notification.region)
          .once("value", async (snapshot) => {
            let region = snapshot.val()

            let selectedBrokers = await getBrokersFromRegions(region, auth);

            console.log("selectedBrokers", selectedBrokers);

            if (selectedBrokers.length !== 0) {
              fetch(
                `${cloud_function_server_url}/send_bulk_notification`,
                {
                  method: "POST",
                  headers: {
                    "Content-Type": "application/json",
                  },
                  body: JSON.stringify({
                    students: selectedBrokers,
                    title: notification.title,
                    msg: notification.msg,
                    content: notification.content,
                  }),
                }
              )
                .then((response) => response?.json())
                .then((results) => {

                })
                .catch((error) => {
                  console.error("Error:", error);
                });
            } else {
              Alert.alert("No Brokers Found");
            }





          })

      }

    } catch (error) {
      dispatch({
        type: SEND_NOTIFICATIONS_FAILURE,
        payload: error,
      });
    }
  };
